import { createElement } from 'react';
import { ElementFactory, Question, Serializer } from 'survey-core';
import { ReactQuestionFactory, SurveyQuestionElementBase } from 'survey-react-ui';
import { PropertyGridEditorCollection } from 'survey-creator-react';
import { Text, Image } from '@chakra-ui/react';

export const CUSTOM_VIEW_MEDIA_TYPE = 'view-media';

export class ViewMediaQuestion extends Question {
   getType() {
      return CUSTOM_VIEW_MEDIA_TYPE;
   }
   get altText() {
      return this.getPropertyValue('altText');
   }
   set altText(val) {
      this.setPropertyValue('altText', val);
   }
   get title() {
      return this.getPropertyValue('title');
   }
   set title(val) {
      this.setPropertyValue('title', val);
   }
   get imageLink() {
      return this.getPropertyValue('imageLink');
   }
   set imageLink(val) {
      this.setPropertyValue('imageLink', val);
   }
   get contentMode() {
      return this.getPropertyValue('contentMode');
   }
   set contentMode(val) {
      this.setPropertyValue('contentMode', val);
   }
   get caption() {
      return this.getPropertyValue('caption');
   }
   set caption(val) {
      this.setPropertyValue('caption', val);
   }
}

export function registerViewMediaQuestion() {
   ElementFactory.Instance.registerElement(CUSTOM_VIEW_MEDIA_TYPE, name => {
      return new ViewMediaQuestion(name);
   });
}

type ViewMediaComponentProps = {
   contentMode: 'image' | 'video';
   imageLink: string;
   caption: string;
   altText: string;
};

const ViewMediaComponent = ({
   contentMode,
   imageLink,
   caption,
   altText,
}: ViewMediaComponentProps) => {
   if (contentMode === 'image') {
      return (
         <>
            <Image src={imageLink} alt={altText} />
            <Text fontSize="lg" pt="20px">
               {caption}
            </Text>
         </>
      );
   } else {
      return (
         <>
            <video controls aria-label={altText}>
               <source src={imageLink} />
            </video>
            <Text fontSize="lg" pt="20px">
               {caption}
            </Text>
         </>
      );
   }
};

Serializer.addClass(
   CUSTOM_VIEW_MEDIA_TYPE,
   [
      {
         name: 'contentMode',
         type: 'string',
      },
      {
         name: 'imageLink',
         type: 'string',
      },
      {
         name: 'title',
         type: 'string',
      },
      {
         name: 'altText',
         type: 'string',
      },
      {
         name: 'caption',
         type: 'string',
      },
   ],
   () => new ViewMediaQuestion(''),
   'question'
);

export class ViewMediaInQuiz extends SurveyQuestionElementBase {
   constructor(props: any) {
      super(props);
      this.state = { value: this.questionBase.value };
   }

   get question() {
      return this.questionBase;
   }
   get value() {
      return this.question.value;
   }
   get contentMode() {
      return this.question.contentMode;
   }
   get altText() {
      return this.question.altText;
   }
   get title() {
      return this.question.title;
   }
   get imageLink() {
      return this.question.imageLink;
   }
   get caption() {
      return this.question.caption;
   }

   renderViewMediaQuestion() {
      return (
         <ViewMediaComponent
            altText={this.altText}
            imageLink={this.imageLink}
            contentMode={this.contentMode}
            caption={this.caption}
         />
      );
   }

   renderElement() {
      return <div>{this.renderViewMediaQuestion()}</div>;
   }
}

ReactQuestionFactory.Instance.registerQuestion(CUSTOM_VIEW_MEDIA_TYPE, props => {
   return createElement(ViewMediaInQuiz, props);
});

PropertyGridEditorCollection.register({
   fit: prop => {
      return prop.type === 'media';
   },
   getJSON: () => {
      return {
         type: CUSTOM_VIEW_MEDIA_TYPE,
      };
   },
});
